import { render, staticRenderFns } from "./StorageSpaceMediaCards.vue?vue&type=template&id=b94544c0&"
import script from "./StorageSpaceMediaCards.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceMediaCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports